<div class="section">
    <div class="section__header">
        <h2 class="section__name">{{props['name']}}</h2>
        <ng-container *ngIf="hasErrors()">
            <p class="section__error">Fields in this section contain errors</p>
        </ng-container>
    </div>
    <ng-container #fieldComponent></ng-container>
</div>

